// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const greedent: PokeData = {
  "id": 820,
  "name": "greedent",
  "height": 6,
  "weight": 60,
  "base_experience": 161,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "tail-whip",
    "bite",
    "counter",
    "rest",
    "super-fang",
    "stockpile",
    "spit-up",
    "swallow",
    "bullet-seed",
    "covet",
    "belch",
    "stuff-cheeks"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "bite",
    "bullet-seed",
    "growl",
    "quick-attack",
    "purification",
    "leer",
    "protect",
    "scary-face",
    "refresh",
    "splash",
    "tri-attack"
  ],
  "evolution_chain": {
    "id": 433,
    "item": null,
    "species": [
      {
        "name": "skwovet",
        "order": 819,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "greedent",
        "order": 820,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 819,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 189,
    "speed": 37,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
